import { CountryEnum } from "./../enums/country.enum";

export default class IsCountryHelper {
  static isBrazil(countryName: string): boolean {
    return countryName.toUpperCase().trim() === CountryEnum.BRAZIL;
  }

  static isArgentina(countryName: string): boolean {
    return countryName.toUpperCase().trim() === CountryEnum.ARGENTINA;
  }
}
